import { render } from "./AppWysylka.vue?vue&type=template&id=26748fe3"
import script from "./AppWysylka.vue?vue&type=script&lang=js"
export * from "./AppWysylka.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__